import { color } from "d3-color";
import { interpolateNumber, interpolateRgb, interpolateString } from "d3-interpolate";
export default function (a, b) {
  var c;
  return (typeof b === "number" ? interpolateNumber : b instanceof color ? interpolateRgb : (c = color(b)) ? (b = c, interpolateRgb) : interpolateString)(a, b);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-transition@1.3.2@d3-transition/src/transition/interpolate.js
// module id = 407
// module chunks = 0